var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isArticoli || _vm.isNewArticolo)?_c('drawer-articoli'):(_vm.isClienti || _vm.isNewClifor || _vm.isEditClifor)?_c('drawer-clienti'):(_vm.isMovimenti)?_c('drawer-movimenti'):(_vm.isDocumenti)?_c('drawer-documenti'):(_vm.isDocumentiDettaglio)?_c('drawer-documenti-dettaglio'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }